import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

import { MapProps } from './Types';
import { Cluster } from '../../types';
import { MARKER_HOVERED_ZINDEX, MARKER_ZINDEX } from './constants';

const useStyles = makeStyles(theme => ({
  wrapper: {
    transform: 'translateX(-50%) translateY(-50%)',
    display: 'inline-block',
    position: 'relative',
    zIndex: MARKER_ZINDEX,
  },
  wrapperHovered: {
    zIndex: MARKER_HOVERED_ZINDEX,
  },
  marker: {
    backgroundColor: 'white',
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    textAlign: 'center',
    border: `2px solid ${theme.palette.mint.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition:
      '-webkit-transform 0.25s cubic-bezier(0.485, 1.65, 0.545, 0.835)',
  },
  hovered: {
    transform: 'scale(1.3)',
  },
}));

interface Props {
  lat: number;
  lng: number;
  cluster: Cluster;
  onPinClick: (coords: number[]) => void;
}

const ClusterMarker: React.FC<Props & Partial<MapProps>> = ({
  cluster,
  onPinClick,
  $hover,
}) => {
  const classes = useStyles();

  return (
    <div className={cx(classes.wrapper, $hover && classes.wrapperHovered)}>
      <div
        onClick={() => onPinClick(cluster.geometry.coordinates)}
        className={cx(classes.marker, $hover && classes.hovered)}
      >
        {cluster.properties.point_count}
      </div>
    </div>
  );
};

export default ClusterMarker;
